/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizer.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
window.theme = window.theme || {};
window.slate = window.slate || {};
    
if (typeof ShopifyAPI === 'undefined') {
  ShopifyAPI = {};
}

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if (typeof attribute !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return String.trim(attribute);
}

function doPoll() {
  setTimeout(function () {
    $.getJSON('/cart.js', function (cart) {
      $('.cart-count').html(cart.item_count);
      doPoll();
    }, 1000);
  })
}

/*============================================================================
  API Functions
==============================================================================*/

/*============================================================================
  ITEM COUNT IN CART
==============================================================================*/
jQuery.getJSON('/cart.js', function (cart) {
  $('.cart-count').html(cart.item_count);
});

ShopifyAPI.onCartUpdate = function (cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function (note, callback) {
  var params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    success: function (cart) {
      if (typeof callback === 'function') {
        callback(cart);
      } else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function (XMLHttpRequest) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (data.message) {
    alert(data.message + '(' + data.status + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/

ShopifyAPI.addItemFromForm = function (form, callback, errorCallback) {
  var formData = new FormData(form);
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: formData,
    processData: false,
    contentType: false,
    dataType: 'json',
    success: function (line_item) {
      if (typeof callback === 'function') {
        callback(line_item, form);
      } else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      if (typeof errorCallback === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      } else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    }
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function (callback) {
  jQuery.getJSON('/cart.js', function (cart) {
    if (typeof callback === 'function') {
      callback(cart);
    } else {
      ShopifyAPI.onCartUpdate(cart);
    }
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function (line, quantity, callback) {
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    success: function (cart) {
      if (typeof callback === 'function') {
        callback(cart);
      } else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/

var ajaxCart = (function (module, $) {
  'use strict';

  // Public functions
  // var init, loadCart, addProducts;

  // Private general variables
  var settings, isUpdating, $body, firstLoad;

  // Private plugin variables
  var $formContainer,
    $addToCart,
    $cartCountSelector,
    $cartCostSelector,
    $cartContainer;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/

  var init = function(options) {
    // Default settings
    settings = {
      /*
      formSelector: '[data-product-form]',
      cartContainer: '#CartContainer',
      addToCartSelector: 'input[type="submit"]',
      cartCountSelector: '.cart-count',
      cartCostSelector: null,
      moneyFormat: '$',
      disableAjaxCart: false,
      enableQtySelectors: true,
      */
      // CSS Selectors
      selectors: {
        ajaxcart: '.mini_cart',
        checkoutButton: '.checkout-btn',
        product: '.ajaxcart__product',
        productSet: '.ajaxcart__product-set',
        productSetEmpty: '.ajaxcart__product-set__empty',
        productTitle: '.yv-product-title',
        qtyWrapper: '.cart-item-quantity"',
        qtyInput: '.ajaxcart__qty-num',
        discountCodeInput: '.ajaxcart__discount-code-input',
        applyDiscount: '.ajaxcart__apply-discount'
      }
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer = $(settings.formSelector);
    $cartContainer = $(settings.cartContainer);
    $addToCart = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector = $(settings.cartCostSelector);

    // General Selectors
    $body = $('body');

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride($formContainer);
    }

    if (!settings.disableAjaxCart) {
      formOverride($('.cross-selling-form'));
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };


  
  let loadCart = function() {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  let updateCountPrice = function(cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    /*if ($cartCostSelector) {
      $cartCostSelector.html(
        theme.Currency.formatMoney(cart.total_price, settings.moneyFormat)
      );
    }*/
  };

  let formOverride = function(form) {
    form.on('submit', function (evt) {
      evt.preventDefault();

      // Add class to be styled if desired
      $addToCart.removeClass('is-loaded').addClass('is-loading');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      ShopifyAPI.addItemFromForm(
        evt.target,
        itemAddedCallback,
        itemErrorCallback
      );
    });
  };

  let addProducts = function(products) {
    let xhr = new XMLHttpRequest();
    xhr.addEventListener('load', () => itemAddedCallback());
    xhr.addEventListener('error', () => itemErrorCallback(xhr));
    xhr.open('POST', window.Shopify.routes.root + 'cart/add.js', true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.send(JSON.stringify({
      items: products
    }));
  }

  let addProductsSilently = function(products) {
    let xhr = new XMLHttpRequest();
    xhr.addEventListener('error', ev => console.error('Error when trying to siltently add products to cart:', ev));
    xhr.open('POST', window.Shopify.routes.root + 'cart/add.js', true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.send(JSON.stringify({
      items: products
    }));
  }

  let changeProductProperty = function(productID, property, value) {
    if (Number.isInteger(productID)) {
      let xhr = new XMLHttpRequest();
      let message = {updates:{}};
      message.updates[String(productID)] = 0;
      xhr.addEventListener('error', ev => console.error('Error when trying to remove ' + String(productID) + ' from cart:', ev));
      xhr.open('POST', window.Shopify.routes.root + 'cart/update.js', true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.send(JSON.stringify(message));
    } else {
      throw new TypeError('Product ID must be an integer, not a ' + typeof productID);
    }
  }

  let removeProduct = function(productID) {
    if (Number.isInteger(productID)) {
      let xhr = new XMLHttpRequest();
      let message = {updates:{}};
      message.updates[String(productID)] = 0;
      xhr.addEventListener('error', ev => console.error('Error when trying to remove ' + String(productID) + ' from cart:', ev));
      xhr.open('POST', window.Shopify.routes.root + 'cart/update.js', true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.send(JSON.stringify(message));
    } else {
      throw new TypeError('Product ID must be an integer, not a ' + typeof productID);
    }
  }

  let itemAddedCallback = function() {
    $addToCart.removeClass('is-loading').addClass('is-loaded');
    // Remove any previous quantity errors
    $('.qty-error').remove();
    ShopifyAPI.getCart(cartUpdateCallback);
    $("body").addClass("side_Drawer_open");
  };

  let itemErrorCallback = function(XMLHttpRequest) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-loading is-loaded');

    if (data.message) {
      if (data.status === 422) {
        $formContainer.after(
          '<div class="errors qty-error">' + data.description + '</div>'
        );
      }
    }
  };

  let cartUpdateCallback = function(cart) {
    // Update quantity and price
    updateCountPrice(cart);
    buildCart(cart);
  };

  let buildCart = function(cart) {

    // Start with a fresh cart div
    $cartContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {
      $cartContainer.append(
        '<p class="cart--empty-message">' +
        theme.strings.cartEmpty +
        '</p>\n' +
        '<p class="cookie-message">' +
        theme.strings.cartCookies +
        '</p>'
      );
      cartCallback(cart);
      return;
    }

    /* Handlebars.js cart layout
    var items = [],
      item = {},
      data = {},
      source = $('#CartTemplate').html(),
      template = Handlebars.compile(source);
    */
    var items = [],
      item = {},
      data = {};

    // Inizializzo i prezzi che saranno visualizzati nel carrello
    var originalPriceInCart = 0;
    var discountedPriceInCart = 0;
              
    // Add each item to our handlebars.js data
    $.each(cart.items, function (index, cartItem) {
      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
       */

      var prodImg;
      var unitPrice = null;
      if (cartItem.image !== null) {
        prodImg = cartItem.image
          .replace(/(\.[^.]*)$/, '_medium$1')
          .replace('http:', '');
      } else {
        prodImg =
          '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
      }

      /*if (cartItem.line_level_discount_allocations.length !== 0) {
        for (var discount in cartItem.line_level_discount_allocations) {
          var amount = cartItem.line_level_discount_allocations[discount].amount;

          cartItem.line_level_discount_allocations[
            discount
          ].formattedAmount = theme.Currency.formatMoney(
            amount,
            settings.moneyFormat
          );
        }
      }

      if (cart.cart_level_discount_applications.length !== 0) {
        for (var cartDiscount in cart.cart_level_discount_applications) {
          var cartAmount =
            cart.cart_level_discount_applications[cartDiscount]
              .total_allocated_amount;

          cart.cart_level_discount_applications[
            cartDiscount
          ].formattedAmount = theme.Currency.formatMoney(
            cartAmount,
            settings.moneyFormat
          );
        }
      }

      if (cartItem.unit_price_measurement) {
        unitPrice = {
          addRefererenceValue:
            cartItem.unit_price_measurement.reference_value !== 1,
          price: theme.Currency.formatMoney(
            cartItem.unit_price,
            settings.moneyFormat
          ),
          reference_value: cartItem.unit_price_measurement.reference_value,
          reference_unit: cartItem.unit_price_measurement.reference_unit
        };
      }*/

      // Parses hidden properties
      const originalProperties = JSON.stringify(cartItem.properties);
      let filteredProperties = {};
      try {
        console.log("cartItem.properties", cartItem.properties);
        if (typeof cartItem.properties === 'object' && cartItem.properties != null && cartItem.properties != undefined) {
          //All properties that contain the "=" char in the key will be automatically hidden in the cart
          filteredProperties = Object.keys(cartItem.properties).filter(key => key.includes('=')).map(key => key.split('='));
          filteredProperties.forEach(property => {
            const propertyKey = property[0];
            const propertyValue = property[1];
            if (!(typeof cartItem.properties[propertyKey] === 'object')) {
              try {
                delete cartItem.properties[property];
              } catch (error) {
                console.error(error);
              }
              cartItem.properties[propertyKey] = { hide: true, value: propertyValue };
            }
          });
          

          // Formats gift message
          try {
            const messageLabel = "Translation missing: it.products.product.gift.message.label";
            if (cartItem.properties.hasOwnProperty(messageLabel)) {
              cartItem.properties[`<b>${messageLabel}</b>`] = `<i>${cartItem.properties[messageLabel]}</i>`;
              delete cartItem.properties[messageLabel];
            }
          } catch (error) {
            console.error(error);
          }
        }
      } catch (error) {
        console.error('Failed to parse hidden properties');
        console.error(error);
      }

      // Popolo la discountLabel, se esiste
      var discountLabel = "";
      var discountCalculatedPrice = 0; 
      /*
      try
      {
          if (cartItem.properties.hasOwnProperty('discountLabel') &&
              cartItem.properties.discountLabel != null)
          {
              var discountLabel = cartItem.properties.discountLabel.value;
          }
          else 
          {
              console.log("DiscountLabel non esiste");

              var discountLabel = "-15%";
            
              var discountCalculatedPrice_temp = cartItem.original_line_price / 0.86 / 100;
              discountCalculatedPrice = Math.round(discountCalculatedPrice_temp) * 100;
              cartItem.original_line_price = discountCalculatedPrice;
          }
      }
      catch (error)
      {
          console.log("Esplode tutto");
      }
      */
      // Create item's data object and add to 'items' array
      item = {
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.quantity > 1 ? cartItem.quantity + 'x ' + cartItem.product_title : cartItem.product_title,
        nameBox: cartItem.quantity > 1 ? cartItem.product_title : cartItem.product_title,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        originalProperties: originalProperties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,

        /*
        price: theme.Currency.formatMoney(
          cartItem.original_line_price,
          settings.moneyFormat
        ),

        singleFullPrice: theme.Currency.formatMoney(
          cartItem.original_line_price,
          settings.moneyFormat
        ),
        discountedPrice: theme.Currency.formatMoney(
          cartItem.final_line_price,
          settings.moneyFormat
        ),
        */
        price: cartItem.original_line_price,
        singleFullPrice: cartItem.original_line_price,
        discountedPrice: cartItem.final_line_price,
        
        discountLabel: discountLabel,
        discountLabelIsFilled: discountLabel != "",

        free: cartItem.product_title == 'Scatola regalo',
        
        discounts: cartItem.line_level_discount_allocations,
        discountsApplied: cartItem.line_level_discount_allocations.length === 0 ? false : true,
        vendor: cartItem.vendor,
        unitPrice: unitPrice,
        anchor: cartItem.product_title != 'Ricamo' && cartItem.product_title != 'Ricamo seta' && cartItem.product_title != 'Scatola regalo'
      };

      try {
        if (item.properties != null) {
          if (item.properties.hasOwnProperty('anchor')) {
            item.anchor = (item.properties.anchor === 'true');
          }
    
          if (item.properties.hasOwnProperty('hideTitleWhenOnSet')) {
            item.hideTitleWhenOnSet = (item.properties.hideTitleWhenOnSet.value === 'true');
          } else {
            //temp v
            item.hideTitleWhenOnSet = cartItem.product_title.split(' ')[0] == 'Completo'
          }

          function isPositiveInteger(n) {
            return 0 === n % (!isNaN(parseFloat(n)) && 0 <= ~~n);
          }

          if (item.properties.hasOwnProperty('originalPrice') &&
              item.properties.hasOwnProperty('discountedPrice') &&
              item.properties.originalPrice != null &&
              item.properties.discountedPrice != null &&
              isPositiveInteger(item.properties.originalPrice.value) &&
              isPositiveInteger(item.properties.discountedPrice.value)) {

            /*
            item.originalPrice = theme.Currency.formatMoney(
              item.properties.originalPrice.value * item.itemQty,
              settings.moneyFormat
            );
            item.discountedPrice = theme.Currency.formatMoney(
              item.properties.discountedPrice.value * item.itemQty,
              settings.moneyFormat
            );
            */
            item.originalPrice = item.properties.originalPrice.value * item.itemQty;
            item.discountedPrice = item.properties.discountedPrice.value * item.itemQty;

            item.discountsApplied = true;

            try 
            {                         
              originalPriceInCart += item.properties.originalPrice.value * item.itemQty;
              discountedPriceInCart += item.properties.discountedPrice.value * item.itemQty; 
            }
            catch (error) 
            {
              console.error("Error (cart):" + error);            
            }
          }
          else 
          { 
            //console.log("Cross-Sell");
            /*
            item.originalPrice = theme.Currency.formatMoney(
              cartItem.original_line_price,
              settings.moneyFormat
            );
            item.discountedPrice  = theme.Currency.formatMoney(
              cartItem.final_line_price,
              settings.moneyFormat
            );
            */
            item.originalPrice = cartItem.original_line_price;
            item.discountedPrice = cartItem.final_line_price;
            
            originalPriceInCart += cartItem.original_line_price;
            
            item.discountsApplied = true;
          };
        }
      } catch (error)
      {
        console.error(error);
      }

      items.push(item);
    });

    let freeShipping = false;
    try {
      let lowerLimitFreeShipping = parseInt("Translation missing: it.cart.general.lower_limit");
      if (lowerLimitFreeShipping > 0 && cart.total_price >= lowerLimitFreeShipping) {
        freeShipping = true;
      }
    } catch (error) {
      console.error(error);
    }

    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      freeShipping: freeShipping,
      /*
      totalPrice: theme.Currency.formatMoney(
        cart.total_price,
        settings.moneyFormat
      ),
      
      totalFullPrice: theme.Currency.formatMoney(
        originalPriceInCart,
        settings.moneyFormat
      ),
      savings: theme.Currency.formatMoney(
        originalPriceInCart - discountedPriceInCart,
        settings.moneyFormat
      ),

      toFreeShipping: theme.Currency.formatMoney(
        parseInt("Translation missing: it.cart.general.lower_limit") - cart.total_price,
        settings.moneyFormat
      ),
      */

      totalPrice: cart.total_price,
      
      totalFullPrice: originalPriceInCart,
      savings: originalPriceInCart - discountedPriceInCart,

      toFreeShipping: parseInt("Translation missing: it.cart.general.lower_limit") - cart.total_price,
      
      cartDiscounts: cart.cart_level_discount_applications,
      cartDiscountsApplied:
        cart.cart_level_discount_applications.length === 0 ? false : true
    };

    //$cartContainer.append(template(data));

    cartCallback(cart);
    //groupElementsByDataSetKey();
  };

  

  
  let postProcessCart = function() 
  {
    let carts = document.querySelectorAll(settings.selectors.ajaxcart);
    console.log(carts);
    carts.forEach(cart=>{
      // product: HTMLElement
      let productSets = {}; //object of arrays of products

      cart.querySelectorAll(settings.selectors.product).forEach(product => {
   
        let setKey = product.dataset.setKey;

         if (setKey != '') {
          if (setKey in productSets) { 
            productSets[setKey].push(product);
          } else {
            productSets[setKey] = [product];
          }
        }
      });
      console.log(productSets.length);
      // Groups product sets
      /*
      Object.values(productSets).forEach((productSet) => {
        let productSetContainer = undefined;
        //arrays of products
        productSet.forEach((product, i) => {
          if (i == 0) {
            productSetContainer = product.closest(settings.selectors.productSet);
            const setTitle = document.createElement('div');
            setTitle.classList.add('ajaxcart__product-set-name');
            setTitle.innerText = product.dataset.setName;
            productSetContainer.prepend(setTitle);
          } else {
            product.closest(settings.selectors.productSet).style.display = 'none';
            productSetContainer.append(product);
          }
          if (i == 1) {
            productSetContainer.classList.add('ajaxcart__product-set--multiple');
          }

          product.querySelector(settings.selectors.qtyWrapper).style.display = 'none';
          if (product.dataset.hideTitleWhenOnSet == "true" || product.dataset.hideTitleWhenOnSet == true) {
            product.querySelector(settings.selectors.productTitle).remove();
          }
        });
      });
*/
      // Empty buttons
      cart.querySelectorAll(settings.selectors.productSetEmpty).forEach(el => {
        el.addEventListener('click', () => {
          let productSet = el.closest(settings.selectors.productSet);
          let qty_list = {};
          productSet.querySelectorAll(settings.selectors.qtyInput).forEach(input => {
            qty_list[input.dataset.key] = 0;
          });
          
          // Transition
          productSet.classList.add(`${settings.selectors.productSet.substring(1)}--hiding`);

          let xhr = new XMLHttpRequest();
          xhr.addEventListener('load', () => {
            productSet.remove();
            adjustCartCallback(JSON.parse(xhr.response));
          });
          xhr.addEventListener('error', () => {
            productSet.classList.remove('${settings.selectors.productSet.substring(1)}--hiding');
          });
          xhr.open('POST', window.Shopify.routes.root + 'cart/update.js', true);
          xhr.setRequestHeader('Content-Type', 'application/json');
          xhr.send(JSON.stringify({
            updates: qty_list
          }));
        });
      });

      //try {
      //  ajaxCartOptional.postProcessCart(cart);
      //} catch (error) {
      //  console.error(error);
      //}
    });

  }

  let updatesQty = function() {
    document.querySelectorAll(".ajaxcart__qty-num").forEach((el) => {
      el.value = String(el.dataset.showvalue);
    });
  } 


  let cartCallback = function(cart) {
    console.log("cartCallback");

    postProcessCart();
    //groupElementsByDataSetKey();
    
    updatesQty();

    $body.removeClass('drawer--is-loading');
    $body.trigger('ajaxCart.afterCartLoad', cart);

    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
  };

  let adjustCart = function() {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function () {
      if (isUpdating) {
        return;
      }
      var $el = $(this),
        line = $el.data('line'),
        $qtySelector = $el.siblings('.ajaxcart__qty-num'),
        qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });

    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function () {
      if (isUpdating) {
        return;
      }
      var $el = $(this),
        line = $el.data('line'),
        qty = parseInt($el.val().replace(/\D/g, ''));

      qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function (evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function () {
      var $el = $(this);
      setTimeout(function () {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__product[data-line="' + line + '"]').addClass(
        'is-loading'
      );

      if (qty === 0) {
        $row.addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function () {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function () {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function () { });
    });
  };

  let adjustCartCallback = function(cart) {
    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function () {
      ShopifyAPI.getCart(buildCart);
      isUpdating = false;
    }, 150);
  };

  let qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var $numInputs = $('input[type="number"]');

    if ($numInputs.length) {
      $numInputs.each(function () {
        var $el = $(this),
          currentQty = $el.val(),
          inputName = $el.attr('name'),
          inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
          itemMinus = currentQty - 1,
          itemQty = currentQty;

        var source = $('#JsQty').html(),
          template = Handlebars.compile(source),
          data = {
            key: $el.data('id'),
            itemQty: itemQty,
            itemAdd: itemAdd,
            itemMinus: itemMinus,
            inputName: inputName,
            inputId: inputId
          };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function () {
        var $el = $(this),
          $qtySelector = $el.siblings('.js-qty__num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }

        // Update the input's number
        $qtySelector.val(qty);
      });
    }
  };

  let validateQty = function(qty) {
    if (parseFloat(qty) === parseInt(qty) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart,
    addProducts: addProducts,
    addProductsSilently: addProductsSilently,
    removeProduct: removeProduct
  };

  return module;
})(ajaxCart || {}, jQuery);

ajaxCart.init({
enableQtySelectors: true
//moneyFormat: theme.strings.moneyFormat
});